export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/local_photography.56958b8.svg";